import * as React from 'react'
import cx from 'classnames'
import * as styles from './expander.circle.styl'

// the component used as custom expander in grid
// isExpanded - expander status (expand/collapse)
// position  - from which side to show this component
// childern -  use the special children prop to pass children elements directly into their output

export enum Position {
  left = 'left',
  right = 'right'
}

export interface ExpanderIconProps {
  isExpanded: boolean
  disabled?: boolean
}

export interface CustomGridExpanderProps {
  role?: string
  isExpanded: boolean
  position?: Position
  disabled?: boolean
}

const ExpanderStyleByPosition = {
  [Position.right]: [styles.right, 'pos-right'],
  [Position.left]: [styles.left, 'pos-left']
}

export const ExpanderIcon: React.FC<ExpanderIconProps> = ({
  isExpanded,
  disabled
}: React.PropsWithChildren<ExpanderIconProps>) => (
  <i className={cx('material-icons', styles.icon, { disabled })}>
    {isExpanded ? 'remove_circle_outline' : 'add_circle_outline'}
  </i>
)

const CustomGridExpander: React.FC<CustomGridExpanderProps> = ({
  isExpanded,
  children,
  disabled,
  role,
  position = Position.left
}: React.PropsWithChildren<CustomGridExpanderProps>) => (
  <span
    role={role}
    className={cx(styles.customExpander, ExpanderStyleByPosition[position])}
  >
    <span
      className={cx(styles.ellipsisContent, ExpanderStyleByPosition[position])}
    >
      {children}
    </span>
    <ExpanderIcon disabled={disabled} isExpanded={isExpanded} />
  </span>
)

export default CustomGridExpander
